export const termsAndConditions = {
  title: "Terms and conditions",
  subtitle:
    "Customize the terms and conditions your customers will see in your store.",
  answerLabel: "Answer",
  clearAnswer: "Clear answer",
  hideTitle: "Hide terms and conditions",
  hideWarning:
    "If you hide this section, your customers will not see the terms and conditions in your store.",
  preview: "Preview",
  save: "Save",
  saving: "Saving...",
  saveSuccess: "Terms and conditions updated successfully",
  saveError: "Could not save terms and conditions",
};
